import localhost from '../../utils/localhost.js';
import axios from 'axios';
import md5 from 'js-md5'

const publisher = {
  state: {
    page: 1
  },
  mutations: {
    publisherPageUpdate (state, data) {
      state.page = data;
    }
  },
  actions: {

  },
  getters: {}
};

export default publisher;



// WEBPACK FOOTER //
// ./src/vuex/modules/publisher.js